import * as Plugins from './plugins';

export const tagManager = {
    Plugins
};
